import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Vajadusel lisa siia toote täiendav viimistlus või kirjelda erisoove toote kohta. Kui sul on kinkekaart, siis kirjuta kinkekaardi kood siia.

  <span style="color:#85c1dc;">**FI:**</span>
  Tarvittaessa lisää tähän täydentävä viimeistely tai kuvaile tuotetta koskevat erikoistoiveet.

  <span style="color:#85c1dc;">**RU:**</span>
  При необходимости добавьте сюда дополнительную отделку изделия или опишите особые пожелания к изделию.
*/
/* @__NO_SIDE_EFFECTS__ */
const m476 = msg(
  mf`Vajadusel lisa siia toote täiendav viimistlus või kirjelda erisoove toote kohta. Kui sul on kinkekaart, siis kirjuta kinkekaardi kood siia.`,
  mf`Tarvittaessa lisää tähän täydentävä viimeistely tai kuvaile tuotetta koskevat erikoistoiveet.`,
  mf`При необходимости добавьте сюда дополнительную отделку изделия или опишите особые пожелания к изделию.`,
)

export { m476 as 'w.basket.order_note_placeholder' }